import { css } from 'styled-components'

export const gatsbyTransitionLinkStyles = css`
  .tl-edges {
    overflow: visible;
  }

  .tl-wrapper {
    float: none;
    overflow: hidden;
  }
`
